export default "__VITE_ASSET__B2hg1X8C__"